import { render, staticRenderFns } from "./PositionDetails.vue?vue&type=template&id=4bc33d05&"
import script from "./PositionDetails.vue?vue&type=script&lang=ts&setup=true&"
export * from "./PositionDetails.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports